<script>
  import GeneralButton from "../button/GeneralButton.svelte";

  export let onClick

  /**
   * @deprecated
   */
  export let type

  export let variant

  export let disabled = false
</script>

<GeneralButton
  buttonType={variant ?? type}
  buttonFunction={onClick}
  buttonExtraStyle="min-width: 160px"
  buttonDisabled={disabled}
>
  <slot />
</GeneralButton>
